import { useEffect, useState } from "react";

import { API } from "config";

interface ApiHealthState {
  isHealthy: boolean | null; // null = checking, true = healthy, false = unhealthy
  error?: Error;
}

export function useApiHealth() {
  const [healthState, setHealthState] = useState<ApiHealthState>({
    isHealthy: null,
  });

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

        const response = await fetch(`${API.cortevaChain.url}/health`, {
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (response.ok) {
          setHealthState({ isHealthy: true });
        } else {
          setHealthState({
            isHealthy: false,
            error: new Error(
              `Health check failed with status ${response.status}`
            ),
          });
        }
      } catch (error) {
        setHealthState({
          isHealthy: false,
          error: error instanceof Error ? error : new Error("Unknown error"),
        });
      }
    };

    checkHealth();
  }, []);

  return healthState;
}
